import { render, staticRenderFns } from "./determinacion-de-las-cuotas-obrero-patronales-bimestrales.vue?vue&type=template&id=2582f030&lang=html&"
import script from "./determinacion-de-las-cuotas-obrero-patronales-bimestrales.vue?vue&type=script&lang=js&"
export * from "./determinacion-de-las-cuotas-obrero-patronales-bimestrales.vue?vue&type=script&lang=js&"
import style0 from "./determinacion-de-las-cuotas-obrero-patronales-bimestrales.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports